import { getGoToTodayMenuItem } from '../commandBarItems/getGoToTodayMenuItem';
import { getSurfaceShareMenuItem } from '../commandBarItems/surface/getSurfaceShareMenuItem';
import { getViewSwitcherMenuItem } from '../commandBarItems/getViewSwitcherMenuItem';
import type { CalendarModuleCommandBarConfig } from '../schema';
import { getSurfaceNavigationMenuItems } from '../commandBarItems/surface/getSurfaceNavigationMenuItems';
import { getSurfacePrintMenuItem } from '../commandBarItems/surface/getSurfacePrintMenuItem';
import { getFeedbackMenuItem } from '../commandBarItems/getFeedbackMenuItem';
import { getSurfaceTimestripMenuItem } from '../commandBarItems/surface/getSurfaceTimestripMenuItem';
import { getFilterMenuItem } from '../commandBarItems/filterMenu/getFilterMenuItem';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { getNewOutlookToggle } from '../commandBarItems/getNewOutlookToggle';
import { isToggleEnabled } from 'native-newoutlook-toggle';

export function getSurfaceCommandBarConfig(
    onCustomRenderSubMenuChange: () => void
): CalendarModuleCommandBarConfig {
    const primaryItems = isFeatureEnabled('mon-ribbon')
        ? []
        : [
              getGoToTodayMenuItem(),
              ...getSurfaceNavigationMenuItems(),
              getSurfaceTimestripMenuItem(),
          ];

    return {
        primaryItems: primaryItems,
        farItems: [
            getViewSwitcherMenuItem(onCustomRenderSubMenuChange),
            ...(isFeatureEnabled('cal-eventsFilterMenu') ? [getFilterMenuItem()] : []),
            getSurfaceShareMenuItem(),
            getSurfacePrintMenuItem(),
            ...(isFeatureEnabled('fwk-feedbackCharm') && isHostAppFeatureEnabled('ribbonFeedback')
                ? [getFeedbackMenuItem()]
                : []),
            ...(isToggleEnabled() ? [getNewOutlookToggle()] : []),
        ],
    };
}
